module.exports = __webpack_public_path__ + "img/yiyao_meili.4c449c12.png";